import { render, staticRenderFns } from "./competitors-widget.html?vue&type=template&id=269862e6&scoped=true&"
import script from "./competitors-widget.js?vue&type=script&lang=js&"
export * from "./competitors-widget.js?vue&type=script&lang=js&"
import style0 from "./competitors-widget.scss?vue&type=style&index=0&id=269862e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269862e6",
  null
  
)

export default component.exports